import { render, staticRenderFns } from "./GetCoins.vue?vue&type=template&id=683a6ece&scoped=true&"
import script from "./GetCoins.vue?vue&type=script&lang=js&"
export * from "./GetCoins.vue?vue&type=script&lang=js&"
import style0 from "./GetCoins.vue?vue&type=style&index=0&id=683a6ece&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683a6ece",
  null
  
)

export default component.exports